<template>
  <div id="app" class='rootWrap'>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang='scss'>
// 公共css
html {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height:100%;
}
body{
  height:100%;
}
body, ul, ol, dl, dd, h1, h2, h3, h4, h5, h6, p, form, fieldset, legend, input, textarea, select, button, th, td {
  margin:0;
  padding:0;
}
body::-webkit-scrollbar {
	// display: none; /* 隐藏滚动条 */
}
div,ul,li,a,p,span,i,h1,h2,h3,header,section,footer,nav,aside,article{box-sizing: border-box;}
li{list-style: none;}
a{text-decoration: none;}
.rootWrap{height:100%;}
/*flex布局*/
.flex{display: flex;display: -webkit-flex;}
/*水平轴是主轴 垂直轴是交叉轴*/
/*单根主轴方向*/
.fd-r{flex-direction: row;}
.fd-rr{flex-direction: row-reverse;}
.fd-c{flex-direction: column;}
.fd-cr{flex-direction: column-reverse;}
/*单根换行*/
.fw-n{flex-wrap: nowrap;}
.fw-w{flex-wrap: wrap;}
.fw-wr{flex-wrap: wrap-reverse;}
/*单根主轴对齐方式*/
.jc-fs{justify-content: flex-start;}
.jc-fe{justify-content: flex-end;}
.jc-c{justify-content: center;}
.jc-sb{justify-content: space-between;}
.jc-fs{justify-content: space-around;}
/*单根交叉轴对齐方式*/
.ai-fs{align-items: flex-start;}
.ai-fe{align-items: flex-end;}
.ai-c{align-items: center;}
.ai-b{align-items: baseline;}
.ai-s{align-items: stretch;}
/*多根交叉轴对齐方式*/
/*父层配合fd-r,fw-w。子层配合width:100%。使用*/
.ac-fs{align-content: flex-start;}
.ac-fe{align-content: flex-end;}
.ac-c{align-content: center;}
.ac-sb{align-content: space-between;}
.ac-sa{align-content: space-around;}
.ac-s{align-content: stretch;}
/*item属性*/
/*项目放大比例 默认0*/
.fg-1{flex-grow:1;}
/*项目缩小比例 默认1*/
.fs-0{flex-shrink:0;}
/*项目自动缩放*/
.f-a{flex: auto;}
/*项目不缩放*/
.f-n{flex: none;}


.contract-boxs-steps{
    padding-bottom: 57px;
    .contract-boxs-steps-solid{
      margin-right: 40px;
      div{
        width: 14px;
        height: 14px;
        border-radius: 50%;
      }
      .solid{
        background: rgba(34, 116, 239, 1);
      }
      .hollow{
        border: 2px solid rgba(34, 116, 239, 1);
      }
    }
    .contract-boxs-steps-div{
      .contract-boxs-steps-div-mess{
        min-height: 91px;
        .contract-boxs-steps-div-mess-time{
          width: 88px;
          height: 32px;
          background: rgba(34, 116, 239, 1);
          text-align: center;
          font-size: 16px;
          line-height: 32px;
          margin-left: 9px;
          top: -11px;
        }
        .contract-boxs-steps-div-mess-time::before {
          content: '';
          position: absolute;
          left: -10px; /* 让三角“伸”到标签左侧 */
          top: 50%;    /* 垂直居中 */
          transform: translateY(-50%);

          /* 边框实现三角：左右下边框透明，上边框为标签色（或按需调整） */
          border-width: 16px 10px 16px 0;
          border-style: solid;
          border-color: transparent rgba(34, 116, 239, 1) transparent transparent;
        }
        .contract-boxs-steps-div-mess-ages{
          padding: 26px 25px 17px 33px;
          border-radius: 10px;
          margin-top: 7px;
          height: 115px;
          background: rgba(247, 251, 254, 1);
          border: 1px solid rgba(238, 238, 238, 1);
          .contract-boxs-steps-div-mess-ages-promoter{
            font-size: 16px;
            line-height: 16px;
            p:nth-of-type(1){
              color: rgba(32, 33, 34, 1);
            }
          }
          .contract-boxs-steps-div-mess-ages-staff{
            .contract-boxs-steps-div-mess-ages-staff-name{
              font-size: 16px;
              width: 268px;
              color: rgba(32, 33, 34, 1);
              margin-left: 20px;
            }
            .contract-boxs-steps-div-mess-ages-staff-input{
              p{
                width: 70px;
                font-size: 16px;
                color: rgba(32, 33, 34, 1);
                line-height: 16px;
              }
              div{
                width: 442px;
                padding: 10px 20px;
                background: rgba(254, 255, 255, 1);
                border: 1px solid rgba(233, 243, 249, 1);
                border-radius: 5px;
                input{
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
      .contract-boxs-steps-div-messtwo{
        min-height: 91px;
        border: 1px solid rgba(238, 238, 238, 1);
        padding: 25px 25px 25px 33px;
        background: rgba(247, 251, 254, 1);
        border-radius: 10px;
        .contract-boxs-steps-div-messtwo-examine{
          font-size: 16px;
          // width: 268px;
        }
        .contract-boxs-steps-div-messtwo-name{
          font-size: 16px;
          width: 268px;
          color: rgba(32, 33, 34, 1);
          margin: 10px 0px 0px 20px;
        }
        .contract-boxs-steps-div-messtwo-input{
          margin: 10px 0px;
          p{
            width: 70px;
            font-size: 16px;
            color: rgba(32, 33, 34, 1);
          }
          div{
            width: 442px;
            padding: 10px 20px;
            background: rgba(254, 255, 255, 1);
            border: 1px solid rgba(233, 243, 249, 1);
            border-radius: 5px;
            input{
              font-size: 16px;
            }
          }
        }
      }
    }
    .contract-boxs-steps-line{
      width: 2px;
      height: 92%;
      background: rgba(229, 241, 249, 1);
      left: 6px;
      bottom: 0px;
    }
  }

  .upload-btn {
    width: fit-content;
    background-color: rgba(174, 193, 206, 1);
    border-radius: 5px;
    padding: 10px 19px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 20px;
    border: none;
    margin: 10px;
  }
  .upload-btn:hover {
    background-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border-radius: 5px;
    border: 1px dashed #8c939d;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue